import { render, staticRenderFns } from "./BodyTraitPreview.vue?vue&type=template&id=1242b80a&scoped=true&"
import script from "./BodyTraitPreview.vue?vue&type=script&lang=ts&"
export * from "./BodyTraitPreview.vue?vue&type=script&lang=ts&"
import style0 from "./BodyTraitPreview.vue?vue&type=style&index=0&id=1242b80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1242b80a",
  null
  
)

export default component.exports